/**
 * No-op Analytics Provider
 *
 * Used when no supported analytics tool is detected on the page.
 * Silently swallows all tracking calls.
 */

import type { AnalyticsProvider } from '../types';

export class NoopProvider implements AnalyticsProvider {
	// eslint-disable-next-line @typescript-eslint/no-empty-function
	track(): void {}
}
